import React, { useState, useCallback, useEffect } from 'react';
import { Badge, Button, List, ListItem, makeStyles, Popover } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import en from '../../lang/en-us';
import { getNotifications, onLogout, readNotification } from '../../redux-store/actions/login';
import {
    NotificationInfo,
    NotificationPayload,
    ReadNotificationInfo,
    ReadNotificationPayload,
} from '../../redux-store/types/login';
import { ACCOUNT_OPTIONS, HOME_PATH, isMobileDevice } from '../../utils/constants';
import { isMobile } from '../../components/quick-links/faq';
import { MouseEventHandler } from 'react';
import { CustomToolTip } from '../DataTable';
import { PurchaseTypes } from '../../components/dashboard/trackStatus/types';

const { common } = en;

const useStyles = makeStyles((theme) => ({
    dot: {
        backgroundColor: 'green',
    },
    mitraLink: {
        color: '#fff',
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        padding: '6px 10px',
        fontFamily: 'Montserrat-SemiBold',
        fontSize: '14px',
        whiteSpace: 'nowrap',
        textDecoration: 'none',
        [theme.breakpoints.down(767)]: {
            display: 'none',
        },
    },
}));
export interface AppBarPropTypes extends RouteComponentProps {
    authorized?: boolean;
    user?: string | null;
    pan: string;
    pekrn: string;
    mobile: string;
    reqId: string;
    notificationCount: number;
    getNotifications: (body: NotificationPayload) => Promise<any>;
    readNotification: (body: ReadNotificationPayload) => Promise<any>;
    onLogout: (body: any) => {};
    showHamburgerMenu?: MouseEventHandler<HTMLAnchorElement>;
}
const {
    signUp: { form },
    dashboard,
} = en;

function Header({
    authorized = false,
    history,
    showHamburgerMenu = () => {},
    user = '',
    ...rest
}: AppBarPropTypes) {
    const [offset, setOffset] = useState(0);
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
    const [notificationAnchorEl, setNotificationAnchorEl] =
        React.useState<HTMLButtonElement | null>(null);
    const [notifications, setNotifications] = useState<NotificationInfo[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const classes = useStyles();

    useEffect(() => {
        window.onscroll = () => {
            setOffset(window.pageYOffset);
        };
    }, []);

    const _getNotifications = useCallback(() => {
        async function callApi() {
            setLoading(true);
            try {
                const { mobile, pan, reqId, pekrn } = rest;
                const response = await rest.getNotifications({ mobile, pan, pekrn, reqId });
                setNotifications(response?.body?.notifications);
            } catch (err: any) {
                alert(err.message);
            } finally {
                setLoading(false);
            }
        }
        callApi();
    }, []);

    useEffect(() => {
        if (notificationAnchorEl) {
            _getNotifications();
        }
    }, [notificationAnchorEl, _getNotifications]);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleNotificationClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setNotificationAnchorEl(event.currentTarget);
    };

    const handleNotificationClose = () => {
        setNotificationAnchorEl(null);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const getNotificationTime = (timeStamp: string) => {
        const date = new Date(timeStamp);
        const currentDate = new Date();
        const _time = date.getTime();
        const _currentTime = currentDate.getTime();
        const minutes = Math.floor((_currentTime - _time) / (1000 * 60));
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);
        const months = Math.floor(days / 30);
        const years = Math.floor(months / 365);
        return years
            ? `${years} year(s) ago`
            : months
            ? `${months} month(s) ago`
            : days
            ? `${days} day(s) ago`
            : hours
            ? `${hours} hour(s) ago`
            : minutes
            ? `${minutes} min ago`
            : 'now';
    };

    const _onRead = (notification: NotificationInfo) => async () => {
        const { mobile, pan, reqId, pekrn } = rest;
        const referenceId = notification.reqId?.split('-')[0];
        const { notificationId, requestType } = notification;
        try {
            await rest.readNotification({
                mobile,
                pan,
                pekrn,
                reqId,
                notifications: [{ notificationId, readStatus: 'Y' }],
            });
            [
                PurchaseTypes.NEW,
                PurchaseTypes.ADDITIONAL,
                PurchaseTypes.SWITCH,
                PurchaseTypes.REDEMPTION,
                PurchaseTypes.STP,
                PurchaseTypes.SWP,
                PurchaseTypes.PROSPECT_FOLIO,
            ].includes(requestType as PurchaseTypes)
                ? history.push(`/portal/track-for-transaction/${referenceId}`)
                : history.push(`/portal/track-for-nct/${referenceId}`);
        } catch (err: any) {
            alert(err.message);
        }
    };

    const onClear = async () => {
        const { mobile, pan, reqId, pekrn } = rest;
        const _notifications: ReadNotificationInfo[] = notifications.map(({ notificationId }) => ({
            notificationId,
            readStatus: 'Y',
        }));
        try {
            await rest.readNotification({
                mobile,
                pan,
                pekrn,
                reqId,
                notifications: _notifications,
            });
            _getNotifications();
        } catch (err: any) {
            alert(err.message);
        }
    };

    const open = Boolean(anchorEl);
    const notificatioOpen = Boolean(notificationAnchorEl);
    const id = open ? 'profile-dropdown' : undefined;
    const notificationsid = notificatioOpen ? 'notifications-dropdown' : undefined;
    const [moreAnchorEl, setMoreAnchorEl] = React.useState<HTMLButtonElement | null>(null);
    const moreOpen = Boolean(moreAnchorEl);

    const moreHandleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setMoreAnchorEl(event.currentTarget);
    };

    const moreHandleClose = () => {
        setMoreAnchorEl(null);
    };

    const { pathname } = rest.location;
    const { path = '' } = rest?.match || {};

    const onMenuClick = async (type: string) => {
        if (type === ACCOUNT_OPTIONS[1]) {
            const { pan, pekrn, mobile } = rest;
            const payload = {
                pan: pan,
                pekrn: pekrn,
                mobile: mobile,
            };
            try {
                await rest.onLogout(payload);
            } catch (err: any) {
                alert(err.message);
            }
        } else if (type === ACCOUNT_OPTIONS[0]) {
            history.push('/portal/profile');
        } else {
        }
    };

    const getLinks = () => {
        return authorized ? (
            <div className="dashboard-header-links">
                <a
                    onClick={() => {
                        window.open(`${window.location.origin}/links/mitra`, '_blank');
                    }}
                    className={classes.mitraLink}
                >
                    MITRA
                    <img
                        className="new-icon"
                        src="/images/new_menu_icon.svg"
                        alt="icon"
                        style={{ marginLeft: '5px', height: '16px' }}
                    />
                </a>
                <Button
                    color="primary"
                    aria-describedby="more-dropdown"
                    onClick={moreHandleClick}
                    className="more-dropdown-btn"
                >
                    <img src="/images/more.svg" alt="icon" />
                </Button>
                <Popover
                    id="more-dropdown"
                    open={moreOpen}
                    anchorEl={moreAnchorEl}
                    onClose={moreHandleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                >
                    <List component="nav" aria-label="secondary mailbox folders">
                        <ListItem>
                            <Link onClick={moreHandleClose} to={'/portal/crm'}>
                                <img src="/images/crm-dark.svg" alt="icon" />
                                {common.serviceDashboard}
                            </Link>
                        </ListItem>
                        <ListItem>
                            <Link onClick={moreHandleClose} to={'/portal/depreq'}>
                                <img src="/images/cdsl.svg" alt="icon" />
                                {common.depReq}
                            </Link>
                        </ListItem>
                        <ListItem>
                            <Link onClick={moreHandleClose} to={'/portal/unclaimed-payout'}>
                                <img src="/images/unclaimed-dark.svg" alt="icon" />
                                {dashboard.dashboardLeft.link5}
                            </Link>
                        </ListItem>
                    </List>
                </Popover>
                <Button
                    onClick={() => {
                        isMobileDevice()
                            ? history.push('/links/faq')
                            : window.open(`${window.location.origin}/links/faq`, '_blank');
                    }}
                    color="primary"
                >
                    <CustomToolTip title={common.FAQ}>
                        <img src="/images/info.svg" alt="info icon" />
                    </CustomToolTip>
                </Button>
                <Button
                    color="primary"
                    aria-describedby={notificationsid}
                    onClick={handleNotificationClick}
                    className="notifications-dropdown-btn"
                >
                    <Badge
                        classes={{ dot: classes.dot }}
                        color="secondary"
                        variant="dot"
                        invisible={!rest.notificationCount}
                    >
                        <img src="/images/bell-white.svg" alt="notification icon" />
                    </Badge>
                </Button>
                <Popover
                    id={notificationsid}
                    open={notificatioOpen}
                    anchorEl={notificationAnchorEl}
                    onClose={handleNotificationClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <div className="notifications-dropdown-outer">
                        <div className="notifications-dropdown">
                            <h3>
                                {dashboard.notifications.notificationsTxt}{' '}
                                {!!rest.notificationCount && (
                                    <a onClick={onClear}>{dashboard.notifications.clearAll}</a>
                                )}
                            </h3>
                            <div className="notifications-dropdown-list">
                                {!notifications.length || loading ? (
                                    !loading ? (
                                        <div className="notifications-dropdown-info">
                                            <h4 className="notifications-na">
                                                {dashboard.notifications.noNotifications}
                                            </h4>
                                        </div>
                                    ) : (
                                        new Array(4).fill({}).map(() => (
                                            <div className="notifications-dropdown-info">
                                                <a className="unread">
                                                    <Skeleton height={15} width={'60%'} />
                                                    <Skeleton height={15} width={'60%'} />
                                                    <Skeleton height={30} />
                                                </a>
                                            </div>
                                        ))
                                    )
                                ) : (
                                    notifications
                                        .sort(
                                            (a: any, b: any) =>
                                                Number(new Date(b.timestamp)) -
                                                Number(new Date(a.timestamp)),
                                        )
                                        .map((notification) => (
                                            <div
                                                onClick={_onRead(notification)}
                                                className="notifications-dropdown-info"
                                            >
                                                <a className="unread">
                                                    <h6>
                                                        {notification.requestTypeDesc}{' '}
                                                        <span>
                                                            {getNotificationTime(
                                                                notification.timestamp,
                                                            )}
                                                        </span>
                                                    </h6>
                                                    <h4>{`Request ${notification.status}`}</h4>
                                                    <p>
                                                        Your Request for {notification.amcName} with
                                                        Request Id{' '}
                                                        <span>
                                                            “
                                                            {`${notification.reqId?.split('-')[0]}`}
                                                            ”
                                                        </span>{' '}
                                                        has been updated to new status{' '}
                                                        {notification.status}.
                                                    </p>
                                                </a>
                                            </div>
                                        ))
                                )}
                            </div>
                        </div>
                    </div>
                </Popover>
                <Button
                    color="primary"
                    aria-describedby={id}
                    onClick={handleClick}
                    className="profile-dropdown-btn"
                >
                    <img src="/images/profile.svg" alt="profile icon" />
                    <span>{user}</span>
                    <img src="/images/small-down-arrow.svg" alt="icon" />
                </Button>
                <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                >
                    <List component="nav" aria-label="secondary mailbox folders">
                        {ACCOUNT_OPTIONS.map((ele) => (
                            <ListItem key={ele}>
                                <a
                                    onClick={() => {
                                        onMenuClick(ele);
                                        handleClose();
                                    }}
                                >
                                    {ele}
                                </a>
                            </ListItem>
                        ))}
                    </List>
                </Popover>
            </div>
        ) : (
            <div className="header-links">
                <a href={`${window.location.origin}/links/mitra`} target="_blank">
                    MITRA
                    <span>
                        <img className="new-icon" src="/images/new_menu_icon.svg" alt="icon" />
                    </span>
                </a>
                {/* <a onClick={() => history.push(`/links/purchase`)}>Explore MF</a> */}
                <a
                    onClick={() => history.push(`/investor/signin`)}
                    className={pathname.includes('/signin') ? 'active' : ''}
                >
                    Sign In
                </a>
                <a
                    onClick={() => history.push(`/investor/signup`)}
                    className={pathname.includes('/signup') ? 'active' : ''}
                >
                    Sign Up
                </a>
            </div>
        );
    };

    return (
        <header className={offset > 50 ? 'active' : ''}>
            <div className="maxWidth">
                {authorized && (
                    <a className="mobile-toggle mobile_mode" onClick={showHamburgerMenu}>
                        <img src="/images/hamburger.svg" alt="hamburger icon" />
                    </a>
                )}
                <a className="header-logo" onClick={() => history.push(HOME_PATH)}>
                    <img src="/images/logo.svg" alt="logo" />
                </a>
                {getLinks()}
            </div>
        </header>
    );
}

export default connect(
    ({ authReducer }: any) => {
        const { mobile, pan, pekrn, reqId, notificationCount } = authReducer;
        return { mobile, pan, pekrn, reqId, notificationCount };
    },
    { onLogout, getNotifications, readNotification },
)(Header);
